











import { Component, Vue } from 'vue-property-decorator'
import CircuitList from '@/components/CircuitList.vue'

@Component({
  components: { CircuitList }
})
export default class CircuitFinder extends Vue {
  navigateBack () {
    this.$router.push({ name: 'dashboard' })
  }
}
